import estimateSampleSize from '@surveyplanet/sample-size-calculator';
import Validator from '@surveyplanet/validator';

class SampleSizeCalculator {
	constructor() {
		this.population = 0;
		this.marginOfError = 0;
		this.confidenceLevel = 0;
		this.render();
		this._initListeners();
	}

	render() {
		this.populationInput =
			document.getElementsByClassName('calc-population')[0];

		this.marginOfErrorInput =
			document.getElementsByClassName('calc-moe')[0];

		this.confidenceLevelInput =
			document.getElementsByClassName('calc-confidence')[0];

		this.result = document.getElementsByClassName('calc-result');

		this.validator = new Validator([
			{
				name: 'calc-population',
				label: 'Population size',
				rules: ['required', 'numeric'],
				message:
					'How many individuals will your sample represent? Enter your total population here.',
			},
			{
				name: 'calc-moe',
				label: 'Margin of error',
				rules: [
					'required',
					'numeric',
					'lessThan[100]',
					'greaterThan[0]',
				],
				message:
					'Your margin of error should be between 1% and 99%. An acceptable value is typically between 4% and 8%.',
			},
			{
				name: 'calc-confidence',
				label: 'Confidence level',
				rules: [
					'required',
					'numeric',
					'lessThan[100]',
					'greaterThan[79]',
				],
				message:
					"Your confidence level should be between 80% and 99%. We recommend using 95% since it's the industry standard.",
			},
		]);

		this.validator.showValidationErrors = true;
	}

	calculateSampleSize() {
		this.validator.validate((errors) => {
			if (errors && errors.length) {
				return null;
			}

			this.population = Number(this.populationInput.value);
			this.marginOfError = Number(this.marginOfErrorInput.value) / 100;
			this.confidenceLevel =
				Number(this.confidenceLevelInput.value) / 100;
			this.sampleSize = estimateSampleSize(
				this.population,
				this.marginOfError,
				this.confidenceLevel
			);
			this.result[0].innerHTML = this.sampleSize;
		});
	}

	inputChangeHandler(e) {
		this.calculateSampleSize();
	}

	_initListeners() {
		this.populationInput.addEventListener(
			'change',
			this.inputChangeHandler.bind(this)
		);
		this.populationInput.addEventListener(
			'keyup',
			this.inputChangeHandler.bind(this)
		);
		this.marginOfErrorInput.addEventListener(
			'change',
			this.inputChangeHandler.bind(this)
		);
		this.marginOfErrorInput.addEventListener(
			'keyup',
			this.inputChangeHandler.bind(this)
		);
		this.confidenceLevelInput.addEventListener(
			'change',
			this.inputChangeHandler.bind(this)
		);
		this.confidenceLevelInput.addEventListener(
			'keyup',
			this.inputChangeHandler.bind(this)
		);
		this.populationInput.dispatchEvent(new Event('change')); // trigger change
	}
}

export default new SampleSizeCalculator();
